import React from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import AddressContent from '../address-content'
import { Iconfont } from '../../../../../components/icon/iconfont'
import { BlackMask } from '../../../../../components/mask'
import BottomToTop from '../../../../../components/transitions/bottom-to-top'
import { FormattedMessage } from 'react-intl'
import Checkbox from '../../../components/checkbox'
import { BigButton } from '../../../../../components/button'


export const SelectedAddress = props => {
    useStyles(classes)
    const { address, onSelect, onAddAddress } = props
    return <div className={classes.SelectedAddress} >
        <div className={classes.Main} onClick={e => onSelect(address)}>
            <AddressContent address={address} />
            <div className={classes.IconArea}>
                <Checkbox selected={address.isDefaultAddress}/>
            </div>
        </div>
        <div className={classes.Footer}>
            <span className={classes.Editor} onClick={e => onAddAddress(address)}>
                <Iconfont className={classes.Icon}>&#xe778;</Iconfont>
                <span className={classes.Label}><FormattedMessage id="edit" defaultMessage="Edit"/></span>
            </span>
        </div>
        
    </div>
}

export const AddressBook = props => {
    useStyles(classes)
    const { addresses, onAddAddress, onSelect } = props
    return <div className={classes.AddressBook}>
        <div className={classes.Addresses}>
            {
                addresses?.map(address => <SelectedAddress onAddAddress={onAddAddress} onSelect={onSelect} key={address.id} address={address} />)
            }
        </div>

        <div className={classes.ShipToOhter}>
            <BigButton onClick={e => onAddAddress()}>
                + {' '}<FormattedMessage id="add_new_address" defaultMessage="Add New Address" />
            </BigButton>
        </div>
    </div>
}


const WrappedEditor = props => {
    useStyles(classes)
    return <React.Fragment>
        <BottomToTop in={props.show} className={classes.AddressContainer}>
            <div>
                <div className={classes.Hd}>
                    <span className={classes.Title}>
                        <FormattedMessage id="address_book" defaultMessage="Address Book" />
                    </span>
                    <Iconfont className={classes.Close} onClick={props.onClose}>&#xe7c9;</Iconfont>
                </div>
                <div className={classes.Bd}>
                    <AddressBook {...props} />
                </div>
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}


export default props => {

    if (typeof window === 'undefined')
        return null

    return ReactDOM.createPortal(
        <WrappedEditor {...props} />,
        document.getElementById('root')
    )
}